import {Injectable} from '@angular/core';
import {isValidNumber, isVoid} from "../utils";
import {ShellClientService} from "../shell-communication/shell-client.service";
import {
    GetSettlementPriceShell,
    GetSettlementPriceShellReply
} from "../shell-communication/shell-operations-protocol";
import {parseOptionTicker} from "../options-common/options.model";

@Injectable({providedIn: 'root'})
export class SettlementPriceService {

    constructor(
        private _shellClient: ShellClientService
    ) {
    }

    private _promises: Record<string, Record<string, Promise<number>>> = {};

    reset() {
        this._promises = {};
    }

    getSettlementPriceWithRequest(ticker: string, expiration: string): Promise<number> {

        let tickerContainer = this._promises[ticker];

        if (isVoid(tickerContainer)) {
           tickerContainer = {};
           this._promises[ticker] = tickerContainer;
        }

        const settlementPricePromise = tickerContainer[expiration];

        if (!isVoid(settlementPricePromise)) {
            return settlementPricePromise;
        }

        if (isVoid(expiration)) {
            if (ticker.startsWith('@')) {
                expiration = parseOptionTicker(ticker)?.expiration;
            }
        }

        if (isVoid(expiration)) {
            return Promise.resolve(undefined);
        }

        const qry = new GetSettlementPriceShell(
            ticker, expiration
        );

        const promise = this._shellClient.processQuery<GetSettlementPriceShellReply>(qry)
            .then(result =>  result?.price);

        tickerContainer[expiration] = promise;

        return promise;
    }
}